import { Entry } from '../Entry'

export function Entry20240201() {
  return (
    <Entry title="Feb 01 2024 - v3.5.13">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15702/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
